import React from "react";
import I18nServicePage from "@/components/I18nServicePage";
import RiseDiscreetCta from "@/components/RiseDiscreetCta";
import { IMG } from "@/lib/config";

export default function DirigeantsCodir() {
  return (
    <I18nServicePage
      i18nKey="codir"
      image={IMG.codir}
      testIdPrefix="codir"
      accentClass="text-accent-pink"
      afterSections={<RiseDiscreetCta />}
    />
  );
}
